"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
;
const wsExecutionContext = {
    executionId: uuid_1.v4(),
    executionStartDate: new Date()
};
exports.getExecutionContext = (methodId) => {
    const currentDate = new Date();
    wsExecutionContext.executionAge =
        +currentDate - +wsExecutionContext.executionStartDate;
    wsExecutionContext.methodId = methodId;
    return { wsExecutionContext };
};
//# sourceMappingURL=execution-context.js.map